'use strict';

/**除去小数部分，返回整数*/
export function intNumber(a){
	return Math.trunc(a);
}
/**判断是正数负数0，还是非数值
*(1)正数
*(-1)负数
*(0)0
*(-0)-0
*('food') NaN
*/
export function judge(a){
	return Math.sign(a);
}
/**数组去重*/
export function repeat(a){
	return [...new Set(a)];
}
/**数组合并*/
export function mergeArray(a,b){
	let _array=[...a,...b];
	return [...new Set(_array)];
}
/**
 * 在数组中找到目标值，并返回其索引
 * @param {number[]} nums
 * @param {number} target
 * @return {number}
 */
export function target(nums, target){
  const findIndex = nums.concat(Infinite).findIndex( ele => ele >= target );
  return findIndex;
}
/**
 * 求时间差值（天数）
 * @param {string} time1
 * @param {string} time2
 * @return {string}
 */
 export function difference(time1,time2){
 	const day=new Date();
 	const data_time1=day(time1.replace(/\-/g,'/')).getTime();
 	const data_time2=day(time2.replace(/\-/g,'/')).getTime();
 	const difference=data_time2-data_time1;
 	const time=parseInt(difference/(1000 * 60 * 60 * 24));
 	return time;
 }
 /**
 * 时间戳转时间(精确到分)
 * @param {string} time
 * @param {string} status
 * @return {string}
 */
 export function turnTime(time,status){
 	const date=new Date(time);
 	const datetime='';
 	if(status=='year'){
 		datetime=date.getFullYear();
 	}else if(status=='month'){
 		datetime=date.getFullYear() + '-' + (date.getMonth() + 1);
 	}else if(status=='day'){
 		datetime=date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
 	}else if(status=='hour'){
 		datetime=date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours();
 	}else if(status=='minutes'){
 		datetime=date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes();
 	}
 	else{
 		datetime=date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
 	}
 	return datetime;
 }
 /**
 * 转码base64和还原
 * @param {string} str
 * @return {string}
 */
 export function base64(str){
 	const base64={
 		 encode(str){
            return  str == null ? null : btoa(encodeURIComponent(str));
          },
          decode(str){
              return str == null ? null : decodeURIComponent(atob(str));
          }
 	}
 }

/**
 * 获取地址栏参数
 * @param {string} url
 * @return {string}
 */
 export function getQueryString(url) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return decodeURIComponent(r[2]);
    };
    return null;
 }
 /**
 * 数组去除空字符串
 * @param {Array} url
 * @return {Array}
 */
 export function empty(array){
  return array.filter((x) => x !== '' )
 }
  /**
 * 判断运行环境（android，ios,微信版本，系统等）
 * @return {String}
 */
 export function operat(){
    let userAgent = navigator.userAgent.toLowerCase();
    let n = function(e) {
        let t = new RegExp(e + "/([^\\s\\_\\-]+)");
        return e = (userAgent.match(t) || [])[1],
        e || !1
    }
    let r = {
        os: function() {
            if(/windows/.test(userAgent)){
                return "windows";
            }else{
                if(/linux/.test(userAgent)){
                    return "linux";
                }else{
                    if(/iphone|ipod|ipad|ios/.test(userAgent)){
                        return "ios";
                    }else{
                        if(/mac/.test(userAgent)){
                            return "mac";
                        }
                    }
                }
            }
            return void 0;
        }(),
        ie: function() {
            return !!(window.ActiveXObject || "ActiveXObject" in window) && ((userAgent.match(/msie\s(\d+)/) || [])[1] || "11")
        }(),
        weixin: n("micromessenger")
    };
    r.android = /android/.test(userAgent);
    r.ios = "ios" === r.os;
    return r;
 }
 